import Button from 'components/button/Button';
import Form from 'components/form/Form';
import NewsletterAdministrationLayout from 'components/newsletter-administration-layout/NewsletterAdministrationLayout';
import TextInput from 'components/form-elements/text-input/TextInput';

import { INewsletterUnsubscribePage } from 'source/NFR.types';

const NewsletterUnsubscribePage: React.FC<INewsletterUnsubscribePage> = ({
  form,
  input,
  layout,
  submitButton,
  title
}) => (
  <NewsletterAdministrationLayout {...layout} className="newsletter-unsubscribe-page">
    <Form {...form} showSubmitButton={false}>
      {title && <h1>{title}</h1>}
      <TextInput className="newsletter-unsubscribe-page--text-input" theme="hiddenLabel" type="text" {...input} />
      <Button theme={['primary', 'large']} type="submit" {...submitButton} />
    </Form>
  </NewsletterAdministrationLayout>
);

NewsletterUnsubscribePage.displayName = 'NewsletterUnsubscribePage';

export default NewsletterUnsubscribePage;
